import React from 'react';
import { Box, Button, Grid, Typography, makeStyles} from '@material-ui/core';
import { Link as RouterLink, useLocation, useHistory } from 'react-router-dom';


import { userIsLogged } from '../../shared/utils/Sessions';
import * as path from '../../routes/paths';

const useStyles = makeStyles((theme) => ({
    root: {
        margin: 'auto',
        // padding: '5% 10% 0% 10%',
        textAlign: 'center',
        width: '90%',
        marginTop: '10%',
    },
    left: {
        [theme.breakpoints.up('md')]: {
            textAlign: 'left',
        }
    },
    right: {
        [theme.breakpoints.up('md')]: {
            textAlign: 'right',
        }
    },
    img: {
        height: 270
        // position: 'absolute',
        // marginLeft: '-35px',
        // marginTop: '-40px',
    },
    message: {
        marginTop: `${theme.spacing(10)}px`,
        textAlign: 'left',
        [theme.breakpoints.down('sm')]: {
            // textAlign: 'justify',
        }
    },
    [theme.breakpoints.down('sm')]: {
        root: {
            marginTop: '10%'
        }
        // textAlign: 'justify',
    }
}));

const IMAGES = {
    number_0  : '/images/theme/number-0.svg',
    number_4  : '/images/theme/number-4.svg',
    surprised : '/images/theme/maintenance.svg',
};

const Maintenance = (props) => {
    const history = useHistory();
    const classes = useStyles();

    return (
        <Grid container spacing={0} className={classes.root}>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                <Box display="inline-flex">
                    <img src={IMAGES.surprised} className={classes.img} />
                </Box>
            </Grid>
            <Grid item xl={6} lg={6} md={6}  sm={12}  xs={12} className={classes.message}>
                <Typography component="div" variant="h1" className="text-violet-300">Nuestro sitio se encuentra en mejoras</Typography>
                <Typography component="div" variant="body1" className="mt-3" >Creamos y mantenemos el funcionamiento de tu plataforma.</Typography>
                <Typography component="div" variant="body1" >Lamentamos los inconvenientes, por favor, regresa más tarde.</Typography>
                <Button color="secondary" variant="outlined" onClick={() => history.push('/')} className="mt-5">Ir a inicio</Button>
            </Grid>
        </Grid>
    )
};

export default Maintenance;
